import { useMemo } from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { useSetAbandonedGiftCookie } from "@qgiv/donation-form";
import { selectIsCms } from "../../redux/slices/configSettingsSlice";
import { selectCmsPageOrder } from "../../redux/slices/cmsSettingsSlice";
import { selectEnableAbandonedGifts } from "../../redux/slices/donationSettingsSlice";
import { selectHasSubmittedForm } from "../../redux/slices/appSettingsSlice";
import { selectAbandonedGiftData } from "../../redux/slices/abandonedGiftSlice";

const ConnectedUseSetAbandonedGiftCookie = () => {
    const {
        ENUMS: { CmsPageStandardizer },
    } = constants;
    const isCms = useSelector(selectIsCms);
    const enableAbandonedGifts = useSelector(selectEnableAbandonedGifts);
    const hasSubmittedForm = useSelector(selectHasSubmittedForm);
    const abandonedGiftData = useSelector(selectAbandonedGiftData);
    const { qgiv_abandoned_gift = "" } = abandonedGiftData;
    const pageOrder = useSelector(selectCmsPageOrder);
    const firstPageInPageOrder = pageOrder[0];
    const isEventListWidget =
        firstPageInPageOrder === CmsPageStandardizer.QGIV_EVENTS;

    const shouldAllowAbandonedGiftCookieSetting = useMemo(() => {
        let allowAbandonedGiftCookieSetting = true;
        if (isCms || isEventListWidget) {
            allowAbandonedGiftCookieSetting = false;
        }
        return allowAbandonedGiftCookieSetting;
    }, [isCms, isEventListWidget]);

    useSetAbandonedGiftCookie({
        enableAbandonedGifts,
        hasSubmittedForm,
        token: qgiv_abandoned_gift,
        shouldAllowAbandonedGiftCookieSetting,
    });
    return null;
};

export default ConnectedUseSetAbandonedGiftCookie;
